import { render } from "./Topics.vue?vue&type=template&id=44d7b5cc"
import script from "./Topics.vue?vue&type=script&lang=js"
export * from "./Topics.vue?vue&type=script&lang=js"
script.render = render

export default script